import { gql } from '@apollo/client';

const query = gql`
  query searchSuggestSuburbs($params: JSONObject) {
    searchSuggestSuburbs(params: $params)
  }
`;

module.exports = query;
